import { useQuery, useLazyQuery } from "@apollo/react-hooks";
import React, { useState, useEffect, Fragment } from "react";
import moment from "moment";
import { DatePicker, Button, Tree, Select, Tooltip, Tabs, Space, Radio, Skeleton, Spin } from "antd";
import { CarryOutOutlined, CheckOutlined, FormOutlined } from '@ant-design/icons';
import DOMPurify from 'dompurify';

import { GET_DASHBOARD_5_TREE_VIEW } from "../graphql/modules/dashboardv2_5";
import { warnNotify } from "../util";

const { RangePicker } = DatePicker;

const ALLOWED_TAGS = ['b', 'strong', 'i', 'em', 'u'];
const ALLOWED_ATTR = [];

export const DashboardV2D5 = () => {
      const [valueExpandCollapse, setValueExpandCollapse] = useState('Collapse');
      const [expandedKeys, setExpandedKeys] = useState([]);
      const [showLine] = useState(true);
      const [showIcon] = useState(false);
      // const [showLeafIcon, setShowLeafIcon] = useState(<CarryOutOutlined />);
      const [showLeafIcon] = useState(false);
      const [defValue] = useState(0);

      const [startDate, setStartDate] = useState('');
      const [endDate, setEndDate] = useState('');

      const [GetDashboard5Data, { data: dashboard5Data, loading: dashboard5Loading, error: dashboard5Error }] = useLazyQuery(GET_DASHBOARD_5_TREE_VIEW, {
        variables: {
          startDate: startDate,
          endDate: endDate,
        },
        fetchPolicy:  "cache-and-network",
      });

      const radioOptions = [
        {
          label: 'Expand All',
          value: 'Expand',
        },
        {
          label: 'Collapse All',
          value: 'Collapse',
        },
      ];
      
      const treeData = [
        {
          title: `General Permit (${defValue})`,
          key: 'PARENT_GENERAL_PERMIT',
          children: [
            {
              title: `B6 - Live Electrical Permit (${defValue})`,
              key: 'GP_B6_LIVE_ELECTRICAL_PERMIT',
            },
            {
              title: `GP FAC (${defValue})`,
              key: 'GP_FAC',
              children: [
                {
                  title: `B7 - SIPP Permit(${defValue})`,
                  key: 'GP_B7_SIPP',
                },
                {
                  title: `B7 - SIPP (AMHS) (${defValue})`,
                  key: 'GP_B7_SIPP_AMHS',
                },
                {
                  title: `B7 - SIPP (CC) (${defValue})`,
                  key: 'GP_B7_SIPP_CC',
                },
                {
                  title: `B7 - SIPP (Urgent) (${defValue})`,
                  key: 'GP_B7_SIPP_URGENT',
                },
                {
                  title: `B7 - SIPP (ASIPP) (${defValue})`,
                  key: 'GP_B7_SIPP_ASIPP',
                },
                {
                  title: `B7 - SIPP (Production Tool) (${defValue})`,
                  key: 'GP_B7_SIPP_PRODUCTION_TOOL',
                },
                {
                  title: `B7 - SIPP (LSS) (${defValue})`,
                  key: 'GP_B7_SIPP_LSS',
                },
              ],
            },
            {
              title: `GP EHS (${defValue})`,
              key: 'GP_EHS',
              children: [
                {
                  title: `A01 - Upload Rish Assessment Form (${defValue})`,
                  key: 'GP_A01_FORM',
                },
                {
                  title: `A02 - Upload Schedule, Work Layout, Traffic Control Plan, Emergency Response Procedure, Escalation Plan (${defValue})`,
                  key: 'GP_A02_FORM',
                },
                {
                  title: `A03 - Uploads for 3D Works (${defValue})`,
                  key: 'GP_A03_FORM',
                },
                {
                  title: `A04 - For gases, initial tool power up of tool (${defValue})`,
                  key: 'GP_A04_FORM',
                },
                {
                  title: `A05 - Ladder Certification (${defValue})`,
                  key: 'GP_A05_FORM',
                },
                {
                  title: `A06 - Materials Lifter/Lifting Equipment, lifting of Pressure Vessel/Aircon within MICRON existing building or Operation (${defValue})`,
                  key: 'GP_A06_FORM',
                },
                {
                  title: `A07 - Proposed use of explosive powered tool/ Projectiles Tools Such as Nail gun or Stapler Gun (${defValue})`,
                  key: 'GP_A07_FORM',
                },
                {
                  title: `A08 - Proposed Excavation works (${defValue})`,
                  key: 'GP_A08_FORM',
                },
                {
                  title: `A09 - Constructing Scaffolding Checklist (${defValue})`,
                  key: 'GP_A09_FORM',
                },
                {
                  title: `A10 - Upload RMF Pre-Entry Checklist (${defValue})`,
                  key: 'GP_A10_FORM',
                },
                {
                  title: `A11 - Upload Self - Retractable Lanyard or Device (SRL/SRD) Record List (${defValue})`,
                  key: 'GP_A11_FORM',
                },
                {
                  title: `A12 - Proposed use of Personnel Lift/MEWP (${defValue})`,
                  key: 'GP_A12_FORM',
                },
                {
                  title: `B1 - HOT WORKS (to count all day of permits) (${defValue})`,
                  key: 'GP_B1_FORM',
                },
                {
                  title: `B2 - CONFIED SPACE (10)`,
                  key: 'GP_B2_FORM',
                },
                {
                  title: `B3 - LIFTING (10)`,
                  key: 'GP_B3_FORM',
                },
                {
                  title: `B4 - WORK AT HEIGHT (to count all week of permits) (${defValue})`,
                  key: 'GP_B4_FORM',
                },
                {
                  title: `B5 - LSS IMPAIRMENT PERMIT (${defValue})`,
                  key: 'GP_B5_FORM',
                },
                {
                  title: `B8 - DIRTY PERMIT (${defValue})`,
                  key: 'GP_B8_FORM',
                },
                {
                  title: `C1 - FAB 10 Environmental Aspect/Impact Assessment - Environmental (${defValue})`,
                  key: 'GP_C1_A_FORM',
                },
                {
                  title: (
                    <>
                      <div>C1 - FAB 10 Environmental Aspect/Impact Assessment - Hazardous Substance if requester choose section 2c, Solid hazardous waste generation or in CO1,</div>
                      <div>"Generate hazardous/ chemical waste (Yes/ No)" choose "yes", then it will assume as Hazardous Substance permit. Otherwise, it will be environmental permit. ({defValue})</div>
                    </>
                    ),
                  key: 'GP_C1_B_FORM',
                },
              ],
            },
          ],
        },
        {
          title: `Tool Install Permit (${defValue})`,
          key: 'PARENT_TOOL_INSTALL_PERMIT',
          children: [
            {
              title: `B6 - Live Electrical Permit (${defValue})`,
              key: 'TI_B6_LIVE_ELECTRICAL_PERMIT',
            },
            {
              title: `TI FAC (20)`,
              key: 'TI_FAC',
              children: [
                {
                  title: `B7 - SIPP permit, if the job type is selected as SIPP (${defValue})`,
                  key: 'TI_B7_SIPP',
                },
                {
                  title: `B7 - SIPP (AMHS), if the job type is selected as AHMS OHT & MTGroup included F10 AMHS and Discipline is FAC Tool Install (${defValue})`,
                  key: 'TI_B7_SIPP_AMHS',
                },
                {
                  title: `B7 - SIPP (CC), if the job type is selected as Dirty Work & MTGroup include F10 CC Team and Discipline is FAC Tool Install (${defValue})`,
                  key: 'TI_B7_SIPP_CC',
                },
                {
                  title: `B7 - SIPP (Urgent) - If the job type is selected as urgent (${defValue})`,
                  key: 'TI_B7_SIPP_URGENT',
                },
                {
                  title: `B7 - SIPP (ASIPP), if the job type is selected as ASIPP (${defValue})`,
                  key: 'TI_B7_SIPP_ASIPP',
                },
                {
                  title: `B7 - SIPP (Production Tool), if the job type is selected as Production Tools (${defValue})`,
                  key: 'TI_B7_SIPP_PRODUCTION_TOOL',
                },
                {
                  title: `B7 - SIPP (LSS), if the job type is selected as LSS (${defValue})`,
                  key: 'TI_B7_SIPP_LSS',
                },
              ],
            },
            {
              title: `TI EHS (${defValue})`,
              key: 'TI_EHS',
              children: [
                {
                  title: `A01 - Upload Rish Assessment Form (${defValue})`,
                  key: 'TI_A01_FORM',
                },
                {
                  title: `A02 - Upload Schedule, Work Layout, Traffic Control Plan, Emergency Response Procedure, Escalation Plan (${defValue})`,
                  key: 'TI_A02_FORM',
                },
                {
                  title: `A03 - Uploads for 3D Works (${defValue})`,
                  key: 'TI_A03_FORM',
                },
                {
                  title: `A04 - For gases, initial tool power up of tool (${defValue})`,
                  key: 'TI_A04_FORM',
                },
                {
                  title: `A05 - Ladder Certification (${defValue})`,
                  key: 'TI_A05_FORM',
                },
                {
                  title: `A06 - Materials Lifter/Lifting Equipment, lifting of Pressure Vessel/Aircon within MICRON existing building or Operation (${defValue})`,
                  key: 'TI_A06_FORM',
                },
                {
                  title: `A07 - Proposed use of explosive powered tool/ Projectiles Tools Such as Nail gun or Stapler Gun (${defValue})`,
                  key: 'TI_A07_FORM',
                },
                {
                  title: `A08 - Proposed Excavation works (${defValue})`,
                  key: 'TI_A08_FORM',
                },
                {
                  title: `A09 - Constructing Scaffolding Checklist (${defValue})`,
                  key: 'TI_A09_FORM',
                },
                {
                  title: `A10 - Upload RMF Pre-Entry Checklist (${defValue})`,
                  key: 'TI_A10_FORM',
                },
                {
                  title: `A11 - Upload Self - Retractable Lanyard or Device (SRL/SRD) Record List (${defValue})`,
                  key: 'TI_A11_FORM',
                },
                {
                  title: `A12 - Proposed use of Personnel Lift/MEWP (${defValue})`,
                  key: 'TI_A12_FORM',
                },
                {
                  title: `B1 - HOT WORKS (to count all day of permits) (${defValue})`,
                  key: 'TI_B1_FORM',
                },
                {
                  title: `B2 - CONFIED SPACE (${defValue})`,
                  key: 'TI_B2_FORM',
                },
                {
                  title: `B3 - LIFTING (${defValue})`,
                  key: 'TI_B3_FORM',
                },
                {
                  title: `B4 - WORK AT HEIGHT (to count all week of permits) (${defValue})`,
                  key: 'TI_B4_FORM',
                },
                {
                  title: `B5 - LSS IMPAIRMENT PERMIT (${defValue})`,
                  key: 'TI_B5_FORM',
                },
                {
                  title: `B8 - DIRTY PERMIT (${defValue})`,
                  key: 'TI_B8_FORM',
                },
                {
                  title: `C1 - FAB 10 Environmental Aspect/Impact Assessment - Environmental (${defValue})`,
                  key: 'TI_C1_A_FORM',
                },
                {
                  title: (
                    <>
                      <div>C1 - FAB 10 Environmental Aspect/Impact Assessment - Hazardous Substance if requester choose section 2c, Solid hazardous waste generation or in CO1,</div>
                      <div>"Generate hazardous/ chemical waste (Yes/ No)" choose "yes", then it will assume as Hazardous Substance permit. Otherwise, it will be environmental permit. ({defValue})</div>
                    </>
                    ),
                  key: 'TI_C1_B_FORM',
                },
              ],
            },
          ],
        },
      ];

      const onChangeExpandCollapseOption = ({ target: { value } }) => {
        setValueExpandCollapse(value);
        if (value === 'Expand') {
          setExpandedKeys(['PARENT_GENERAL_PERMIT', 'GP_B6_LIVE_ELECTRICAL_PERMIT', 'GP_FAC', 'GP_EHS', 'PARENT_TOOL_INSTALL_PERMIT', 'TI_B6_LIVE_ELECTRICAL_PERMIT', 'TI_FAC', 'TI_EHS']);
        } else {
          setExpandedKeys([]);
        }
      };

      const onSelect = (selectedKeys, info) => {
        console.log('selected', selectedKeys, info);
      };

      const handleDateFrom = (dates, dateStrings) => {
        if (dates) {
            const formattedDates = dates.map(date => date.format('YYYY-MM-DD'));
            console.log(formattedDates);
            setStartDate(formattedDates[0]);
            setEndDate(formattedDates[1]);
        } else {
            console.log('No dates selected');
        }
      };

      const handleSubmit = () => {
        console.log('Start Date: ', startDate);
        console.log('End Date: ', endDate);

        if(startDate === '' || endDate === '') {
          warnNotify('Please select date range');
        }

        if(startDate !== '' && endDate !== '') {
          GetDashboard5Data();
        }
      }

      function retrofitResponse(response) {
        const transformChildren = (children) => {
          return children.map(child => ({
            title: <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(child.title, {ALLOWED_TAGS, ALLOWED_ATTR}) }} />,
            key: child.key
          }));
        };
      
        const treeData = [
          {
            title: <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(response.generalPermit.title, {ALLOWED_TAGS, ALLOWED_ATTR}) }} />,
            key: response.generalPermit.key,
            children: [
              {
                title: <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(response.generalPermit.b6Permits.title, {ALLOWED_TAGS, ALLOWED_ATTR}) }} />,
                key: response.generalPermit.b6Permits.key,
              },
              {
                title: <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(response.generalPermit.facPermits.title, {ALLOWED_TAGS, ALLOWED_ATTR}) }} />,
                key: response.generalPermit.facPermits.key,
                children: transformChildren(response.generalPermit.facPermits.children)
              },
              {
                title: <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(response.generalPermit.ehsPermits.title, {ALLOWED_TAGS, ALLOWED_ATTR}) }} />,
                key: response.generalPermit.ehsPermits.key,
                children: transformChildren(response.generalPermit.ehsPermits.children)
              }
            ]
          },
          {
            title: <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(response.toolInstallPermit.title, {ALLOWED_TAGS, ALLOWED_ATTR}) }} />,
            key: response.toolInstallPermit.key,
            children: [
              {
                title: <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(response.toolInstallPermit.b6Permits.title, {ALLOWED_TAGS, ALLOWED_ATTR}) }} />,
                key: response.toolInstallPermit.b6Permits.key,
              },
              {
                title: <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(response.toolInstallPermit.facPermits.title, {ALLOWED_TAGS, ALLOWED_ATTR}) }} />,
                key: response.toolInstallPermit.facPermits.key,
                children: transformChildren(response.toolInstallPermit.facPermits.children)
              },
              {
                title: <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(response.toolInstallPermit.ehsPermits.title, {ALLOWED_TAGS, ALLOWED_ATTR}) }} />,
                key: response.toolInstallPermit.ehsPermits.key,
                children: transformChildren(response.toolInstallPermit.ehsPermits.children)
              }
            ]
          }
        ];
      
        return treeData;
      }
      
    return (
        <Fragment>

            <div className="row dec-row">
                <div className="card">
                <div className="col-12 col-md-12">
                    <div className="col-12 col-md-12 text-left">
                        <h4 className="text-left">General and Tool Install Permit Count by Child Permit</h4>
                    </div>

                    <div className="row dec-row">
                        <div className="col-12 col-md-12">
                            <div className="col-3 col-md-3">
                                    <Space
                                        className="col-12 col-md-12"
                                        direction="vertical"
                                        size="middle"
                                    >

                                        <div className="col-12 col-md-12">
                                            <RangePicker 
                                                style={{ width: "100%" }}
                                                id={{
                                                  start: 'startInput',
                                                  end: 'endInput',
                                                }}
                                              onChange={handleDateFrom}
                                            />
                                        </div>

                                        <div className="col-12 col-md-12">
                                            <Button
                                                style={{
                                                    width: '100%',
                                                }}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    handleSubmit();
                                                }}
                                            >
                                                Submit
                                            </Button>
                                        </div>
                                    </Space>
                            </div>

                            <div className="col-9 col-md-9">
                                  <div className="card">
                                    <div className="col-12 col-md-12">
                                      <Radio.Group
                                        style={{ width: "100%" }}
                                        options={radioOptions}
                                        onChange={onChangeExpandCollapseOption}
                                        value={valueExpandCollapse}
                                        optionType="button"
                                        buttonStyle="solid"
                                      />
                                    </div>
                                    <br />
                                    <Spin spinning={dashboard5Loading} tip="Loading Tree View">
                                      <Tree
                                        showLine={
                                          showLine ?  { showLeafIcon } : false
                                        }
                                        showIcon={showIcon}
                                        expandedKeys={expandedKeys}
                                        onExpand={(keys) => setExpandedKeys(keys)}
                                        onSelect={onSelect}
                                        treeData={dashboard5Data ? retrofitResponse(dashboard5Data?.GetDashboard5Data?.results) : treeData}
                                      />
                                    </Spin>
                                  </div>
                                  <p><i>Permit status: Pending, PendingApproval, Approved, Pending Closure, Completed, Cancelled, Rejected</i></p>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </Fragment>
    )
}